import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import ReactCodeInput from 'react-verification-code-input';

import { Popup } from 'semantic-ui-react';
import styles from '../AddPhone.module.scss';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import { PhoneUser, LoadingState } from '../../types';

interface VerifyPhoneFormProps {
  loading: LoadingState;
  error?: string;
  user: PhoneUser;
  onSuccess?: () => void;
  verifyActionType: string;
  onVerifyPhone: (code: string) => void;
  resendActionType: string;
  onResend: () => void;
}

function VerifyPhoneForm({
  loading,
  error,
  user,
  onSuccess,
  verifyActionType: VERIFY_ACTION_TYPE,
  onVerifyPhone,
  resendActionType: RESEND_ACTION_TYPE,
  onResend
}: VerifyPhoneFormProps) {
  const { phoneVerified } = user;
  useEffect(() => {
    if (phoneVerified && onSuccess) {
      onSuccess();
    }
  }, [phoneVerified]);

  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);
  const handleChange = () => {
    if (!hasChanged) {
      setHasChanged(true);
    }
  };
  const handleComplete = (code: string) => {
    setHasChanged(false);
    if (!hasSubmitted) {
      setHasSubmitted(true);
    }
    onVerifyPhone(code);
  };

  return (
    <div className={classnames(styles.AddPhone, 'component', 'custom')}>
      <h2 className="modalTitle">Verify Phone Number</h2>

      <img src="/img/illustrations/addPhone.svg" alt="" />
      <div className={styles.codeInput}>
        <label htmlFor="verificationCode">Verification Code</label>
        <Popup
          open={
            !hasChanged && hasSubmitted && !loading[VERIFY_ACTION_TYPE] && !!error
          }
          trigger={
            <ReactCodeInput
              fields={4}
              onComplete={handleComplete}
              onChange={handleChange}
              fieldWidth={45}
              fieldHeight={60}
              className="font-family-inter!"
            />
          }
          position="bottom center"
        >
          {error}
        </Popup>
      </div>
      <Button
        className={styles.resendVerification}
        type={ButtonType.Secondary}
        loading={loading[RESEND_ACTION_TYPE]}
        onClick={onResend}
      >
        Re-send Verification Code
      </Button>
    </div>
  );
}

export default VerifyPhoneForm;
